
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../Styles/Login.css";

function Login() {

    const navigate = useNavigate();

    const [adminId, setAdminId] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {

        e.preventDefault();

        if (!adminId || !password) {
            alert("Please enter Admin ID and Password");
            return;
        }

        try {

            setLoading(true);

            const response = await axios.post(
                "/api/admin/login",
                null,
                {
                    params: {
                        adminId: adminId,
                        password: password
                    }
                }
            );

            console.log("Login successful:", response.data);

            // Store logged-in admin details
            localStorage.setItem(
                "admin",
                JSON.stringify(response.data)
            );

            // Go to Dashboard
            navigate("/dashboard");

        } catch (error) {

            console.error("Login error:", error);

            console.log(
                "Error message:",
                error.message
            );

            console.log(
                "Error response:",
                error.response
            );

            console.log(
                "Error request:",
                error.request
            );

            // Server responded with an error
            if (error.response) {

                let serverMessage = "";

                if (typeof error.response.data === "string") {
                    serverMessage = error.response.data;
                } else {
                    serverMessage =
                        JSON.stringify(error.response.data);
                }

                alert(
                    "Login failed.\n\n" +
                    "Status: " +
                    error.response.status +
                    "\nMessage: " +
                    serverMessage
                );

            }

            // Request sent but no response
            else if (error.request) {

                alert(
                    "Request was sent, but no response came from Spring Boot.\n\n" +
                    "Please check that Spring Boot is running on port 8080."
                );

            }

            // Request could not be created
            else {

                alert(
                    "Login request error:\n\n" +
                    error.message
                );

            }

        } finally {

            setLoading(false);

        }
    };


    return (

        <div className="login-container">

            <div className="login-box">

                <h2>Admin Login</h2>

                <form onSubmit={handleLogin}>

                    <label>
                        Admin ID
                    </label>

                    <input
                        type="text"
                        placeholder="Enter Admin ID"
                        value={adminId}
                        onChange={(e) =>
                            setAdminId(e.target.value)
                        }
                    />

                    <label>
                        Password
                    </label>

                    <input
                        type="password"
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                    />

                    <button
                        type="submit"
                        disabled={loading}
                    >
                        {loading
                            ? "Logging in..."
                            : "Login"}
                    </button>

                </form>

            </div>

        </div>

    );
}

export default Login;

